import { Box, BoxProps, MenuItem, Select, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"

type Props = {
  sx?: BoxProps
  name?: string
  required?: boolean
  readOnly?: boolean
  selected: string | number | boolean
  handleSelected: any
  datas: { name: string; value: any }[]
  inputStyle?: any
  labelStyle?: any
  disabled?: boolean
  validationMessage?: string
  description?: string
  textDescription?: string
  placeholder?: string
  hasText?: boolean
  text?: string
  handleText?: any
  checkValidation?: any
}

const SelectField = ({
  sx,
  name,
  required,
  readOnly,
  selected,
  handleSelected,
  datas,
  inputStyle,
  disabled,
  validationMessage,
  description,
  textDescription,
  placeholder,
  hasText,
  text,
  handleText,
  checkValidation,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "base" })

  const isMobile = useMediaQuery({ query: "(max-width: 680px)" })

  const [isOther, setIsOther] = useState<boolean>(false)

  useEffect(() => {
    for (let i = 0; i < datas?.length; i++) {
      if (datas[i].value === selected) {
        if (datas[i].name === "その他") {
          setIsOther(true)
          return
        }
      }
    }
    setIsOther(false)
  }, [selected])

  const style = sx || {}

  const customStyle = {
    "& ::before": {
      borderColor: "#d4d3d7 !important",
    },
  }

  return (
    <Box
      sx={{
        width: "355px",
        ...style,
        ...customStyle,
      }}
    >
      <Box display="flex">
        <Typography className="name">{name}</Typography>
        {required && (
          <Box className="required-container">
            <Typography className="required">{t("required")}</Typography>
          </Box>
        )}
      </Box>
      <Select
        variant="outlined"
        sx={{
          width: "340px",
          ...inputStyle,
          mt: name ? "10px" : "0px",
          mb: 0,
          ".Mui-readOnly": {
            backgroundColor: "#EAF1FB",
          },
          ".MuiSelect-icon": {
            fill: "#00C298 !important",
          },
          "& fieldset": { borderColor: "#F3F3F3" },
          fontFamily: "Zen Kaku Gothic New !important",
        }}
        value={selected}
        onChange={(event) => {
          handleSelected(event.target.value)
          if (checkValidation) {
            checkValidation()
          }
        }}
        disabled={disabled}
        readOnly={readOnly}
        className={selected == "none" ? "gray" : ""}
      >
        {placeholder && (
          <MenuItem
            value="none"
            key={0}
            disabled
            sx={{ display: "none", fontFamily: "Zen Kaku Gothic New !important", fontSize: "15px" }}
          >
            {placeholder}
          </MenuItem>
        )}
        {datas.map((data, index) => {
          return (
            <MenuItem
              value={data.value}
              key={index}
              sx={{ fontFamily: "Zen Kaku Gothic New !important", fontSize: "14px" }}
            >
              {data.name}
            </MenuItem>
          )
        })}
      </Select>
      {hasText && isOther && (
        <>
          <TextField
            value={text}
            onChange={(event) => handleText(event.target.value)}
            InputProps={{ readOnly: readOnly }}
            sx={{ mt: "20px", ...(isMobile ? { width: "100%" } : {}) }}
          />
          {!validationMessage && (
            <Box sx={{ height: "20px", pt: "5px" }}>
              <Typography className="description">{textDescription}</Typography>
            </Box>
          )}
        </>
      )}
      {validationMessage ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description error">{validationMessage}</Typography>
        </Box>
      ) : description ? (
        <Box sx={{ height: "20px", pt: "5px" }}>
          <Typography className="description">{description}</Typography>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default SelectField
